import React from "react";

export default function Breadcrumb({ path, setPath }) {
  const parts = path ? path.split("/") : [];

  return (
    <div className="breadcrumb">
      <span className="crumb" onClick={() => setPath("")}>🏠 Trang chủ</span>
      {parts.map((p, i) => {
        const sub = parts.slice(0, i + 1).join("/");
        return (
          <React.Fragment key={i}>
            <span className="crumb-sep">/</span>
            <span className="crumb" onClick={() => setPath(sub)}>{p}</span>
          </React.Fragment>
        );
      })}
    </div>
  );
}
